import { useEffect, useState } from "react";
import { api, type AdminStage } from "../lib/api";
import { useGame } from "../store";

interface Props {
  groupId: string;
}

/** Operator controls (shown with ?admin): jump to a stage, clear chat. */
export function AdminBar({ groupId }: Props): React.ReactElement {
  const [stages, setStages] = useState<AdminStage[]>([]);
  const [selected, setSelected] = useState("");
  const setMessages = useGame((s) => s.setMessages);

  useEffect(() => {
    void api.populatePositionBar(groupId).then((res) => {
      if (res.success !== 1) return;
      setStages(res.arc.payload);
      setSelected(res.current_key);
    });
  }, [groupId]);

  const force = async () => {
    const res = await api.forceToStage(groupId, selected);
    if (res.success !== 1) alert(`Error: ${res.error_message}`);
  };

  const clear = async () => {
    const res = await api.deleteAllMessages(groupId);
    if (res.success === 1) setMessages([]);
    else alert(`Error: ${res.error_message}`);
  };

  return (
    <div className="admin-bar">
      <strong>ADMIN</strong>
      <select value={selected} onChange={(e) => setSelected(e.target.value)}>
        {stages.map((s) => (
          <option key={s.segment_id} value={s.segment_id}>
            {s.desc ?? s.segment_id}
          </option>
        ))}
      </select>
      <button className="btn secondary" onClick={() => void force()}>
        Start stage
      </button>
      <button className="btn secondary" onClick={() => void clear()}>
        Delete messages
      </button>
    </div>
  );
}
